import { useEffect } from "react";

// Closes an open dropdown/menu when the user scrolls anywhere on the page.
// `onClose` runs on scroll; `active` gates the listener so it only binds
// while the menu is open. Capture phase (`true`) catches scrolls inside
// nested scroll containers too.
const useCloseOnScroll = (onClose, active = true) => {
  useEffect(() => {
    if (!active) return;
    const handleScroll = () => onClose();
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);
};

export default useCloseOnScroll;
